import React from "react";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import ngcEnterpriseLogo from "../assets/ngcEnterpriseLogo.png";
import Enterprise from "../assets/Enterprise.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocation } from "@fortawesome/free-solid-svg-icons";

const NavigationBar = () => {
  return (
    <div>
      <Navbar
        bg="light"
        width="100%"
        // fixed="top"
        // className="opacity-75"
        style={{ height: "50px" }}
      >
        <Container>
          <Navbar.Brand href="#home" className="me-auto">
            <img
              alt=""
              src={ngcEnterpriseLogo}
              width="60"
              height="60"
              className="me-auto"
            />{" "}
          </Navbar.Brand>
          <Nav className="ms-auto">
            <Nav.Link href="#home"> Mon-Fri: 08am - 05pm</Nav.Link>
            <Nav.Link href="#features"></Nav.Link>
            {/* <Nav.Link href="#pricing">(+63)912-345-678</Nav.Link> */}
          </Nav>
        </Container>
      </Navbar>
    </div>
  );
};

export default NavigationBar;
